import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-tooltip-template',
  templateUrl: './tooltip-template.component.html',
  styleUrls: ['./tooltip-template.component.scss']
})
export class TooltipTemplateComponent implements OnInit {
  @Input() public label: string;

  constructor() { }

  ngOnInit(): void {
  }

}
